import {
  Box,
  Button,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { useEffect, useLayoutEffect, useState } from 'react'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { focusElemnt, navigation1 } from '../../common/helper'
import DropDownOA from '../../common/dropDownOA'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import {  outDeliveryStatus, urls, xlCol } from '../../common/constants'
import { GetRequest } from '../../common/api'
import useToken from '../../helpers/useTokens'
import { getTableStatus, getExcelHeaderDataList, getOutDeliveryFilterPlaceholders, getAllOptionLabel, translateOutDeliveryStatus } from './const'
import { useTranslation } from '../../../i18n/I18nProvider'
import { useAtom, useAtomValue } from 'jotai'
import { useRef } from 'react'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import IconButton from '@mui/material/IconButton';
import { exportToExcel } from '../../common/hook'
import { callAddFontRobotoBold } from '../../common/font/Roboto-bold'
import jsPDF from 'jspdf'
import { callAddFontRobotoMedium } from '../../common/font/Roboto-Medium-normal'
import { withPxWidths } from '../../common/mathHelper'
import { makeTable } from '../Reports/analysisReport/pdfAutotable'
import { lrDetailPdfFooter } from '../AcountingReport/common/AcountingConstants'
import autoTable from 'jspdf-autotable'
const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
export const OutDeliveryStatus = () => {
  const { translations } = useTranslation()
  const od = translations?.outDelivery || {}
  const cmn = translations?.common || {}
  const fp = getOutDeliveryFilterPlaceholders(translations)
  const viewHeaders = getTableStatus(translations)
  const excelHeaderDataList = getExcelHeaderDataList(translations)
  const allLabel = getAllOptionLabel(translations)
  const reportName = od.outDeliveryStatus || outDeliveryStatus
  const [companySettings] = useAtom(companySettingsAtom)
  const { DefaultCurrencyID } = companySettings
  const [selectedRadio, setSelectedRadio] = useState(1)
  const [memoFromDate, setMemoFromDate] = useState(moment(new Date()))
  const [memoToDate, setMemoToDate] = useState(moment(new Date()))
  const [tillDate, setTillDate] = useState(false)
  const theme = useTheme()
  const [isExpanded, setIsExpanded] = useState(false)
  const [showMore, setShowMore] = useState(false)
  const { loginData } = useToken()
  const [tableHeight, setTableHeight] = useState('auto')
  const { intBranchID, intCompanyID, intUserID, intBranchCityID, IsBranchAdmin, IsMTPLAdmin, IsAdmin } = loginData
  const roleRights = useAtomValue(CargoRoleRightsAtom)
  const RoleRights = roleRights?.Table1?.[0] || {}
  const { AllowViewAllBranchReport, AllowViewAllBranchOfCityReport } = RoleRights
  const enableBranchChange = AllowViewAllBranchReport || AllowViewAllBranchOfCityReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const enableCityChange = AllowViewAllBranchReport || IsBranchAdmin || IsMTPLAdmin || IsAdmin
  const [sourceCityList, setSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [sourceBranchListFilter, setSourceBranchListFilter] = useState([])
  const [userList, setUserList] = useState([])
  const [userListFilter, setUserListFilter] = useState([])
  const [statusList, setStatusList] = useState([])

  const [sourceCity, setSourceCity] = useState({})
  const [sourceBranch, setSourceBranch] = useState({})
  const [user, setUser] = useState({})
  const [status, setStatus] = useState({})

  const [dataList, setDataList] = useState([])
  const [tableData, setTableData] = useState([])
  const tableRef = useRef(null)
  const [filterValues, setFilterValues] = useState({})
  const { palette: cs } = theme
  const [filters, setFilters] = useState({})
  const [challanList, setChallanList] = useState([])
  const [senderNameList, setSenderNameList] = useState([])
  const [senderNumberList, setSenderNumberList] = useState([])
  const [senderGSTNList, setSenderGSTNList] = useState([])
  const [challanFilter, setChallanFilter] = useState({})
  const [senderNameFilter, setSenderNameFilter] = useState({})
  const [senderNumberFilter, setSenderNumberFilter] = useState({})
  const [senderGSTNFilter, setSenderGSTNFilter] = useState({})
  const [showPrintExcelBtn, setShowPrintExcelBtn] = useState(false)
  const [showPdfView, setShowPdfView] = useState(false)
  const handleChange = (e) => {
    setSelectedRadio(+e.target.value)
  }
  useEffect(() => {
    if (!dataList.length) return
    const filtered = dataList.filter((row) => {
      return viewHeaders.every((col) => {
        const filterVal = filterValues[col.field] || ''
        if (!filterVal) return true
        const cellValue = row[col.field] ?? ''
        return cellValue.toString().toLowerCase().includes(filterVal.toLowerCase())
      })
    })
    setTableData(filtered)
  }, [filterValues])

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (!tableRef.current) return
      const rect = tableRef.current.getBoundingClientRect()
      const top = rect.top
      const viewportHeight = window.innerHeight
      const bottomPadding = 15
      const availableHeight = viewportHeight - top - bottomPadding

      setTableHeight(`${availableHeight}px`)
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)
    window.addEventListener('scroll', updateHeight)

    return () => {
      window.removeEventListener('resize', updateHeight)
      window.removeEventListener('scroll', updateHeight)
    }
  }, [])


  const handleKeyDown = (e) => {
    if (e.key === ' ') {
      setSelectedRadio(+e.target.value)
    }
  }
  const handleToggle = () => {
    setShowMore(!showMore)
  }
  const handleGo = async () => {
    const payload = {
      CompanyID: intCompanyID,
      UserID: intUserID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      Mode: selectedRadio,
      CityID: 0,
      BranchID: 0,
      AssignedUserID: 0,
      Status: -1,
    }
    try {
      const response = await GetRequest(urls.getOutForDeliveryDetails, payload)
      if (response.status === 'Success') {
        const list = response?.Data?.Table || []
        const { sourceCityList, sourceBranchList, userList, statusList } = list.reduce(
          (acc, item) => {
            const { CityName, CityID, BranchID, BranchName, AssignedUserID, AssignedUser, StatusID, Status } = item
            if (!acc.set1.has(CityID)) {
              acc.sourceCityList.push({ id: CityID, name: CityName })
              acc.set1.add(CityID)
            }
            if (!acc.set2.has(BranchID)) {
              acc.sourceBranchList.push({ id: BranchID, name: BranchName, cityid: CityID })
              acc.set2.add(BranchID)
            }
            if (!acc.set3.has(AssignedUserID)) {
              acc.userList.push({ id: AssignedUserID, name: AssignedUser, cityid: CityID, branchid: BranchID })
              acc.set3.add(AssignedUserID)
            }
            if (!acc.set4.has(StatusID)) {
              acc.statusList.push({ id: StatusID, name: Status })
              acc.set4.add(StatusID)
            }
            return acc
          },
          {
            sourceCityList: [],
            sourceBranchList: [],
            userList: [],
            statusList: [],
            set1: new Set(),
            set2: new Set(),
            set3: new Set(),
            set4: new Set(),
          }
        )
        if (sourceCityList.length) {
          if (sourceCityList.length > 1) {
            sourceCityList.unshift({ id: 0, name: allLabel })
          }
          setSourceCityList(sourceCityList)
          setSourceCity(sourceCityList[0])
        }
        if (sourceBranchList.length) {
          if (sourceBranchList.length > 1) {
            sourceBranchList.unshift({ id: 0, name: allLabel })
          }
          setSourceBranchList(sourceBranchList)
          setSourceBranchListFilter(sourceBranchList)
          setSourceBranch(sourceBranchList[0])
        }
        if (userList.length) {
          if (userList.length > 1) {
            userList.unshift({ id: 0, name: allLabel })
          }
          setUserList(userList)
          setUserListFilter(userList)
          setUser(userList[0])
        }
        if (statusList.length) {
          const updatedStatusList = statusList.map((item) =>
            item.id === 0 ? { ...item, name: od.statusAssigned || 'Assigned' } : item
          )
          if (updatedStatusList.length > 1) {
            updatedStatusList.unshift({ id: -1, name: allLabel })
          }
          setStatusList(updatedStatusList)
          setStatus(updatedStatusList[0])
        }
      }
    } catch (error) {}
  }

  const handleGenerate = async () => {
    const payload = {
      CompanyID: intCompanyID,
      UserID: intUserID,
      FromDate: memoFromDate.format('YYYY-MM-DD'),
      ToDate: memoToDate.format('YYYY-MM-DD'),
      Mode: selectedRadio,
      CityID: sourceCity.id,
      BranchID: sourceBranch.id,
      AssignedUserID: user.id,
      Status: status.id,
    }
    try {
      const response = await GetRequest(urls.getOutForDeliveryDetails, payload)
      if (response.status === 'Success') {
        setShowPrintExcelBtn(true)
        setShowPdfView(false) 
        const temp = response?.Data?.Table1 || []
        const dataList = temp.map((item, index) => ({
          ...item,
          SN:index+1,
          dataType:'entry',
          ReceiveDateTime: moment(item.ReceiveDateTime).format('DD-MMM-YY hh:mm A'),
          DeliveryAssignedDate: moment(item.DeliveryAssignedDate).format('DD-MMM-YY hh:mm A'),
        }))
        setDataList(dataList)
        setTableData(dataList)
        const { challanList, senderNameList, senderNumberList, senderGSTNList } = dataList.reduce(
          (acc, item, i) => {
            const { ChallanNo, Sender, SenderMobileNo, SenderGSTN } = item
            if (!acc.set1.has(ChallanNo) && ChallanNo) {
              acc.challanList.push({ id: i, name: ChallanNo })
              acc.set1.add(ChallanNo)
            }
            if (!acc.set2.has(Sender) && Sender) {
              acc.senderNameList.push({ id: i, name: Sender })
              acc.set2.add(Sender)
            }
            if (!acc.set3.has(SenderMobileNo) && SenderMobileNo) {
              acc.senderNumberList.push({ id: i, name: SenderMobileNo })
              acc.set3.add(SenderMobileNo)
            }
            if (!acc.set4.has(SenderGSTN) && SenderGSTN) {
              acc.senderGSTNList.push({ id: i, name: SenderGSTN })
              acc.set4.add(SenderGSTN)
            }
            return acc
          },
          {
            challanList: [],
            senderNameList: [],
            senderNumberList: [],
            senderGSTNList: [],
            set1: new Set(),
            set2: new Set(),
            set3: new Set(),
            set4: new Set(),
          }
        )
        setChallanList(challanList)
        setSenderNameList(senderNameList)
        setSenderNumberList(senderNumberList)
        setSenderGSTNList(senderGSTNList)
      }
    } catch {}
  }
  const handleChangeContain = (e, name) => {
    let value = e.target.value
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value,
    }))
  }
    const handleMoreFilter = () => {
    const filtered = dataList.filter((item) => Object.entries(filters).every(([key, value]) => item[key] === value))
    setTableData(filtered)
  }
  const handleFilterReset = () => {
    setFilters({})
    setChallanFilter({ id: 0, name: '' })
    setSenderNameFilter({ id: 0, name: '' })
    setSenderNumberFilter({ id: 0, name: '' })
    setSenderGSTNFilter({ id: 0, name: '' })
    setTableData(dataList)
  }
  const handleFromCitySelect = (city) => {
    setSourceCity(city)
    setIsExpanded(false)
    const filterList = city?.id ? sourceBranchList.filter((a) => a.cityid === city?.id) : sourceBranchList
    if (filterList.length > 1 && city?.id) {
      filterList.unshift({ id: 0, name: allLabel })
    }
    setSourceBranchListFilter(filterList)
    setSourceBranch(filterList?.[0] || {})
    const filterUserList = city?.id ? userList.filter((a) => a.cityid === city?.id) : userList
    setUserListFilter(filterUserList)
    setUser(filterUserList?.[0] || {})
  }
  const criteriaDataExcel={
    fromDate: memoFromDate.format('DD-MMM-YYYY'),
    toDate: memoToDate.format('DD-MMM-YYYY'),
    CityName: sourceCity.name,
    BranchName: sourceBranch.name,
    UserName: user.name,
    Status: status.name,
    dataType:'entry'
  }
  const header1 = [
    [
      { header: `Report For: ${reportName}`, field: '', span: viewHeaders.length/2, mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: viewHeaders.length/2 },
    ],
  ]
  const columnDef=viewHeaders?.filter((item) => item.field!=='PODLink')?.map((h) => ({
    header: h.headerName,
    exportHead: h.exportHead || h.headerName,
    field: h.field,
    xlCol: h.xlCol,
    weight: h.weight,
  }))
  const excelHeaderList = [header1, excelHeaderDataList,columnDef ]
  const excelDataList = [[], [criteriaDataExcel],tableData]
  const printClick = (isSave) => {
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = excelHeaderDataList.map((col) => {
      return { header: col.header, dataKey: col.field, xlCol: col.xlCol || xlCol }
    })
    const pdfFontSize = 1
    const orientation = columnDef.length > 14 ? 'l' : 'p'
    const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
    const pdfColumns = withPxWidths(columnDef, format[0] - 60).map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0 }
    })
    const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `${reportName}.pdf`,
      subject: `${reportName}`,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    const customFunction = (data, doc) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont('Roboto', 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text(`Cargo System | ${reportName}`, 30 + 60, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont('Roboto', 'bold')
      doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    }
    const customFunction2 = (data, doc) => {
      lrDetailPdfFooter(data, loginData, totalPagesExp)
    }
    makeTable(doc, autoTable, HeaderColumns, [criteriaDataExcel], pdfFontSize, reportName, loginData, 'everyPage', customFunction, 120, false)
    makeTable(doc, autoTable, pdfColumns, tableData, pdfFontSize, reportName, loginData,'everyPage', customFunction2)

    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${reportName} ${currentDateTime}.pdf`)
    } else {
    }
    setTimeout(() => {
      const pdfUrl = doc.output('bloburl')
      document.getElementById('anaLRDetailsOutput').data = pdfUrl
      focusElemnt('backBtn')
    }, 2000)
  }
  return (
    <Item sx={{ padding: '0' }} className="reports">
      <Box
        sx={sx.itemsx}
        style={{
          display: 'flex',
          marginRight: '5px',
        }}
      >
        <label
          htmlFor={'isBookingDateWise'}
          style={{
            fontFamily: 'Roboto',
            fontSize: '12px',
            fontWeight: '500',
            color: '#444444',
            flexWrap: 'nowrap',
          }}
        >
          <Radio
            id={'isBookingDateWise'}
            name={`dateWiseRadio`}
            size={'medium'}
            value="1"
            checked={selectedRadio === 1}
            onChange={handleChange}
            onKeyDown={(e) => handleKeyDown(e)}
          />
          {od.bookingDateWise || 'Booking Date Wise'}
        </label>
        <label
          htmlFor={'isDelvryDateWise'}
          style={{
            fontSize: '12px',
            fontFamily: 'Roboto',
            fontWeight: '500',
            color: '#444444',
            flexWrap: 'nowrap',
          }}
        >
          <Radio
            id={'isDelvryDateWise'}
            name={`dateWiseRadio`}
            size={'medium'}
            value="2"
            checked={selectedRadio === 2}
            onChange={handleChange}
            onKeyDown={(e) => handleKeyDown(e)}
          />
          {od.receiveDateWise || 'Receive Date Wise'}
        </label>
      </Box>
      <Box sx={{ ...sx.reportFlex, paddingLeft: '15px', justifyContent: 'start', paddingBottom: '12px' }}>
        <Item sx={{ ...sx.itemsx, width: '19%' }} className="input--container bookingDatePicker">
          <Datepicker
            id="memoFromDate"
            width="100%"
            label={selectedRadio === 1 ? (od.fromBookingDate || 'From Booking Date') : (od.fromReceiveDate || 'From Receive Date')}
            value={memoFromDate}
            dateChange={(date) => {
              setMemoFromDate(date)
              focusElemnt('memoToDate')
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }} className="input--container bookingDatePicker">
          <Datepicker
            id="memoToDate"
            width="100%"
            label={selectedRadio === 1 ? (od.toBookingDate || 'To Booking Date') : (od.toReceiveDate || 'To Receive Date')}
            value={memoToDate}
            statusChecked={tillDate}
            dateChange={(date) => {
              setMemoToDate(date)
              focusElemnt('memoByDate')
            }}
          />
        </Item>
        <Button
          id="memoNext1"
          style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px' }}
          onKeyDown={(e) => {
            navigation1(e, 'memoSourceCity', 'memoAllLr')
          }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={handleGo}
        >
          {cmn.go || 'GO'}
        </Button>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            id="memoSourceCity"
            nextId="memoDestCity"
            prevId="memoNext1"
            label={od.selectCity || 'Select City'}
            type ={'set_default'}
            width="100%"
            searchPlaceholder={od.searchSourceCity || `Search City`}
            defaultvalue={sourceCity?.name || ''}
            value={sourceCity?.name || ''}
            data={sourceCityList}
            dataKey={`name`}
            idKey={`id`}
            onSelect={handleFromCitySelect}
            onSelResetVal={true}
            disabled={!enableCityChange}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            id="memoDestCity"
            nextId="memoGenerate"
            prevId="memoSourceCity"
            label={od.selectBranch || 'Select Branch'}
            type ={'set_default'}
            defaultvalue={sourceBranch?.name || ''}
            value={sourceBranch?.name || ''}
            width="100%"
            searchPlaceholder={od.searchSourceBranch || `Search Branch`}
            data={sourceBranchListFilter}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(value) => {
              setSourceBranch(value)
              setIsExpanded(false)
              const filterUserList = value?.id ? userList.filter((a) => a.branchid === value.id) : userList
              setUserListFilter(filterUserList)
              setUser(filterUserList?.[0] || {})
            }}
            onSelResetVal={true}
            disabled={!enableBranchChange}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            id="memoDestCity"
            nextId="memoGenerate"
            prevId="memoSourceCity"
            label={od.selectUser || 'Select User'}
            defaultvalue={user?.name || ''}
            value={user?.name || ''}
            width="100%"
            type ={'set_default'}
            searchPlaceholder={od.searchSelectUser || `Search Select User`}
            data={userListFilter}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(value) => {
              setUser(value)
              setIsExpanded(false)
            }}
            onSelResetVal={true}
            disabled={!enableBranchChange}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '19%' }}>
          <DropDownOA
            id="memoDestCity"
            nextId="memoGenerate"
            prevId="memoSourceCity"
            label={od.selectStatus || 'Select Status'}
            type ={'set_default'}
            defaultvalue={status?.name || ''}
            value={status?.name || ''}
            width="100%"
            searchPlaceholder={od.selectStatus || `Search Select Status`}
            data={statusList}
            dataKey={`name`}
            idKey={`id`}
            onSelect={(value) => {
              setStatus(value)
              setIsExpanded(false)
            }}
            onSelResetVal={true}
          />
        </Item>
        <Box sx={{ ...sx.reportFlex, padding: '0px', justifyContent: 'start', width: '40%', flexWrap: 'nowrap' }}>
          <Button
            id="memoGenerate"
            className="btn add-btn"
            style={{ margin: '0px', width: '100%', flex: 1 }}
            variant="contained"
            color="error"
            onClick={handleGenerate}
            onKeyDown={(e) => {
              navigation1(e, 'memoToggleFilter', 'memoDestCity')
            }}
          >
            {cmn.generate || od.generate || 'generate'}
          </Button>
          <Button
            id="memoToggleFilter"
            variant="text"
            color="primary"
            endIcon={showMore ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            onClick={handleToggle}
            onKeyDown={(e) => {
              navigation1(e, showMore ? 'memoPaymentType' : 'memoPrintBtn', 'memoGenerate')
            }}
            style={{
              textDecoration: 'underline',
              border: 'none',
              boxShadow: 'none',
              outline: 'none',
              fontWeight: 'bold',
              paddingLeft: '0px 0px',
              fontSize: '12px',
              width: '130px',
              flex: 1,
              width: '100%',
            }}
          >
            {showMore ? (od.lessFilters || 'Less Filters') : (od.moreFilters || 'More Filters')}
          </Button>
          {!showPdfView?
            showPrintExcelBtn && (
              <Box sx={{ display: 'flex', gap: '8px', marginLeft: 'auto' }}>
                <Button
                  sx={{
                    color: '#fe5200',
                    border: '1px solid #fe5200',
                    '&:hover': {
                      backgroundColor: '#fe5200',
                      color: '#fff',
                      border: '1px solid #fe5200'
                    }
                  }}
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() =>
                    exportToExcel({
                      fileName: `${reportName} ${currentDateTime}.xlsx`,
                      sheetName: reportName,
                      headersList: excelHeaderList,
                      dataList: excelDataList,
                    })
                  }
                  id="anaxportAsPdfBtn"
                >
                  {od.exportToExcel || cmn.exportToExcel || 'Export to Excel'}
                </Button>
                <Button
                  style={{ color: '#fe5200', border: '1px solid #fe5200' }}
                  variant="outlined"
                  className="userWisereporttembtn"
                  id="anaxportAsPdfBtn"
                  onClick={() => {
                    setShowPdfView(true)
                    printClick(true)
                  }}
                >
                  {od.exportToPdf || cmn.exportToPdf || 'Export to Pdf'}
                </Button>
                <Button
                  style={{ color: '#fe5200', border: '1px solid #fe5200' }}
                  variant="outlined"
                  className="userWisereporttembtn"
                  id="anaxportAsPrintBtn"
                  onClick={() => {
                    setShowPdfView(true)
                    printClick(false)
                  }}
                >
                  {od.print || cmn.print || 'Print'}
                </Button>
              </Box>) :
              <>
                <Box>
                  <Button
                    id="backBtn"
                    variant="outlined"
                    className="userWisereporttembtn"
                    sx={{
                      color: '#fe5200',
                      border: '1px solid #fe5200',
                      '&:hover': {
                        backgroundColor: '#fe5200',
                        color: '#fff',
                        border: '1px solid #fe5200'
                      }
                    }}
                    onClick={() => {
                      setShowPdfView(false)
                    }}
                  >
                    {od.back || cmn.back || 'Back'}
                  </Button>
                </Box>
              </>
          }
        </Box>
      </Box>
      <Box
        sx={{
          ...sx.reportFlex,
          justifyContent: 'start',
          paddingLeft: '15px',
          display: showMore ? 'flex' : 'none',
          paddingTop: 0,
          paddingBottom: '12px',
        }}
      >
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            idKey={`id`}
            dataKey={`name`}
            id="memoPaymentType"
            width="100%"
            label={od.challanNo || 'Challan No'}
            type ={'set_default'}
            defaultvalue={challanFilter?.name || ''}
            value={challanFilter?.name || ''}
            data={challanList}
            noCross={true}
            onSelect={(val) => {
              setChallanFilter(val)
              setFilters((prev) => ({ ...prev, ChallanNo: val.name }))
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            idKey={`id`}
            dataKey={`name`}
            id="memoPaymentType"
            width="100%"
            label={od.senderName || 'Sender Name'}
            type ={'set_default'}
            value={senderNameFilter?.name || ''}
            defaultvalue={senderNameFilter?.name || ''}
            data={senderNameList}
            noCross={true}
            onSelect={(val) => {
              setSenderNameFilter(val)
              setFilters((prev) => ({ ...prev, Sender: val.name }))
            }}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, width: '15%' }}>
          <DropDownOA
            idKey={`id`}
            dataKey={`name`}
            type ={'set_default'}
            id="memoPaymentType"
            width="100%"
            label={od.senderMobileNo || 'Sender Mobile No'}
            defaultvalue={senderNumberFilter?.name || ''}
            value={senderNumberFilter?.name || ''}
            data={senderNumberList}
            noCross={true}
            onSelect={(val) => {
              setSenderNumberFilter(val)
              setFilters((prev) => ({ ...prev, SenderMobileNo: val.name }))
            }}
          />
        </Item>
        {DefaultCurrencyID === 2 ? (
          <></>
        ) : (
          <Item sx={{ ...sx.itemsx, width: '15%' }}>
            <DropDownOA
              idKey={`id`}
              dataKey={`name`}
              type ={'set_default'}
              id="memoPaymentType"
              width="100%"
              label={od.senderGSTN || 'Sender GSTN'}
              defaultvalue={senderGSTNFilter?.name || ''}
              value={senderGSTNFilter?.name || ''}
              data={senderGSTNList}
              noCross={true}
              onSelect={(val) => {
                setSenderGSTNFilter(val)
                setFilters((prev) => ({ ...prev, SenderGSTN: val.name }))
              }}
            />
          </Item>
        )}
        <Button
          id="memoNext2"
          style={{ background: cs.secondary.main, borderRadius: '6px', margin: '0px' }}
          onKeyDown={(e) => {
            navigation1(e, 'memoSourceCity', 'memoAllLr')
          }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={handleMoreFilter}
        >
          {cmn.go || 'GO'}
        </Button>
        <Button
          id="memoGenerate"
          className="btn cancel-btn"
          style={{ margin: '0px' }}
          variant="outlined"
          color="error"
          onKeyDown={(e) => {
            navigation1(e, 'memoToggleFilter', 'memoDestCity')
          }}
          onClick={handleFilterReset}
        >
          {cmn.reset || 'RESET'}
        </Button>
      </Box>
      <Box
        sx={{ ...sx.reportFlex, padding: '0 0 0 15px', justifyContent: 'start', flexWrap: 'nowrap', fontSize: '16px', fontWeight: 'bold' }}
      >
        {reportName}
      </Box>
      {!showPdfView ?
        <TableContainer
          className="delivery-memo-table scroll"
          component={Paper}
          ref={tableRef}
          sx={{
            height: tableHeight,
            borderRadius: '8px',
            border: '1px solid #aeaeae',
            overflow: 'auto',
            margin: '0px auto',
            width: 'calc(100% - 30px)',
          }}
        >
          <Table aria-label="a dense table">
            <TableHead>
              <TableRow sx={{ width: '100%', position: 'sticky', top: 0, zIndex: 1 }}>
                {viewHeaders.map((header) => (
                  <TableCell
                    key={header.field}
                    style={{
                      textAlign: header.xlCol.dataType === 'string' ? 'left' : 'right',
                      color: '#FFFFFF',
                      backgroundColor: cs.primary.main,
                      fontSize: '12px',
                      fontWeight: 500,
                      padding: '5px',
                      whiteSpace: 'pre',
                    }}
                  >
                    {header.headerName}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow sx={{ width: '100%', position: 'sticky', zIndex: 1 }}>
                {viewHeaders.map((col, index) =>
                  col.showfilter !== false ? (
                    <TableCell key={`FTH-${index}`} style={{ padding: '6px 6px', backgroundColor: '#fff' }}>
                      <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                        <input
                          id={`index-${index}`}
                          className="field"
                          name="cancelSearchInput"
                          style={{ width: '100%', height: '24px' }}
                          placeholder={fp.contains}
                          onChange={(e) => handleChangeContain(e, col.field)}
                        />
                        <FilterAltIcon style={{ color: '#aaa' }} />
                      </div>
                    </TableCell>
                  ) : (
                    <TableCell></TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((row, index) => {
                return (
                  <TableRow key={index}>
                    {viewHeaders.map((header) => {
                      return (
                        <TableCell
                          key={header.field}
                          style={{
                            textAlign: header?.xlCol?.dataType === 'string' ? 'left' : 'right',
                            fontSize: '14px',
                            fontWeight: 500,
                            padding: '5px',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {header.field === 'PODLink' ? (
                            row.PODLink ? (
                              <IconButton
                                onClick={() => window.open(row.PODLink, '_blank')}
                              >
                                <PictureAsPdfIcon style={{ color: 'red' }} />
                              </IconButton>
                            ) : (
                              <div style={{ paddingLeft: '13px' }}>-</div>
                            )
                          ) : header.field === 'Status' ? (
                            translateOutDeliveryStatus(row[header.field], translations)
                          ) : (
                            row[header.field]
                          )}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer> :
        <object
          id="anaLRDetailsOutput"
          type="application/pdf"
          width={'100%'}
          height={`${window.innerHeight - 100}px`}
          title={`${od.cargoSystemReport || 'MTLPL -Cargo System -'}${reportName}`}
          aria-label={`${od.cargoSystemReport || 'MTLPL -Cargo System -'}${reportName}`}
        ></object>
      }
    </Item>
  )
}
